import axios from "axios";
import { toast } from "react-toastify";
import {decryptData} from '../crypto'


const baseURL = process.env.REACT_APP_API_BASE_URL;

const axios_instance = axios.create({
  baseURL:baseURL
});

export async function getRZPKey() {
  try {
    var response = await axios_instance.get(`v1/api/razorpay/key`); 
    console.log('Response:', response);
    return response;
  } catch (err) {
    console.error('Error in getRZPKey:', err);
    if (
      err?.response?.data?.message === "Invalid or expired token. Please refresh your session."
    ) {
      window.location.reload();
      localStorage.clear();
    } else if (
      err?.response?.data?.message === "You are logged out. Please log in again."
    ) {
      window.location.reload();
      localStorage.clear();
    } else if (err?.response?.data?.message) {
      toast.error(err?.response?.data?.message);
    }
  }
}



export async function UpgradePlan(payload, token) {
  try {
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    
    const response = await axios_instance.post(`v1/b2b/upgradeplan`, payload, { headers });
    console.log('UpgradePlan response:', response);
    return response;
  } catch (err) {
    console.error('Error in UpgradePlan:', err);
    if (
      err?.response?.data?.message === "Invalid or expired token. Please refresh your session."
    ) {
      window.location.reload();
      localStorage.clear();
    } else if (
      err?.response?.data?.message === "You are logged out. Please log in again."
    ) {
      window.location.reload();
      localStorage.clear();
    } else if (err?.response?.data?.message) {
      toast.error(err?.response?.data?.message);
    }
  }
}

export const fetchQuestionPaperApi = async (examId) => {
  // const decryptedToken = decryptData(sessionStorage.getItem("examToken"));
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/by_exam/${examId}`,
      {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API error:", error);
    // Check if the error has a response with a message
    if (error.response && error.response.data && error.response.data.message) {
      return { success: false, message: error.response.data.message };
    } else {
      // If no specific error message found, return a generic message
      return {
        success: false,
        message: "An error occurred during the API request.",
      };
    }
  }
};